export default __webpack_public_path__ + "static/media/General's Helm of the Eastern Sun.7c3ed4f5.jpg";